import type { RouteRecordRaw } from 'vue-router'
import Dashboard from '@/views/Dashboard.vue'

const dashboardRoutes: RouteRecordRaw[] = [
  {
    path: '/',
    redirect: '/dashboard'
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta: { 
      requiresAuth: true,
      requiredItem: 'dashboard',
      title: 'Dashboard',
      breadcrumbTitle: 'Início'
    }
  }
]

export default dashboardRoutes